import type React from "react";

interface TemplatePreviewIconProps {
  className?: string;
  isSelected?: boolean;
}

export const TemplateBarChartIcon02: React.FC<TemplatePreviewIconProps> = ({ className, isSelected }) => {
  // Selected: purple colors (#D6BBFB, #6941C6)
  // Unselected: gray colors (#E9EAEB, #A4A7AE)
  const colors = isSelected ? { light: "#D6BBFB", dark: "#6941C6" } : { light: "#E9EAEB", dark: "#A4A7AE" };

  return (
    <svg
      width="122"
      height="118"
      viewBox="0 0 122 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_template04)">
        {/* Bar 1 - Short */}
        <g clipPath="url(#clip1_template04)">
          <path d="M8 80H32V118H8V80Z" fill={colors.light} />
          <path d="M8 103.75H32V118H8V103.75Z" fill={colors.dark} />
        </g>

        {/* Bar 2 - Medium */}
        <g clipPath="url(#clip2_template04)">
          <path d="M35.5 48H59.5V118H35.5V48Z" fill={colors.light} />
          <path d="M35.5 91.75H59.5V118H35.5V91.75Z" fill={colors.dark} />
        </g>

        {/* Bar 3 - Tall */}
        <g clipPath="url(#clip3_template04)">
          <path d="M63 16H87V118H63V16Z" fill={colors.light} />
          <path d="M63 72H87V118H63V72Z" fill={colors.dark} />
        </g>

        {/* Bar 4 - Medium-Short */}
        <g clipPath="url(#clip4_template04)">
          <path d="M90.5 56H114.5V118H90.5V56Z" fill={colors.light} />
          <path d="M90.5 87.25H114.5V118H90.5V87.25Z" fill={colors.dark} />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_template04">
          <rect width="122" height="118" fill="white" />
        </clipPath>
        <clipPath id="clip1_template04">
          <path d="M8 84C8 81.7909 9.79086 80 12 80H28C30.2091 80 32 81.7909 32 84V118H8V84Z" fill="white" />
        </clipPath>
        <clipPath id="clip2_template04">
          <path
            d="M35.5 52C35.5 49.7909 37.2909 48 39.5 48H55.5C57.7091 48 59.5 49.7909 59.5 52V118H35.5V52Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip3_template04">
          <path d="M63 20C63 17.7909 64.7909 16 67 16H83C85.2091 16 87 17.7909 87 20V118H63V20Z" fill="white" />
        </clipPath>
        <clipPath id="clip4_template04">
          <path
            d="M90.5 60C90.5 57.7909 92.2909 56 94.5 56H110.5C112.709 56 114.5 57.7909 114.5 60V118H90.5V60Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
